export enum BotMarketType {
  SPOT = 'SPOT',
  FUTURE = 'FUTURE',
}
